import { YieldType } from "../../../service/globalTypes";
import { sendYieldValue } from "../../../service/store/utils";

import { ResendPricesStatusListArgs } from "../types";

export const resendPricesStatusList = async ({ yields }: ResendPricesStatusListArgs) => {
  const resentedPricesRequestsResults: { yieldType: YieldType; sentSuccessfully: boolean; statusCode: number }[] = [];

  for (const data of yields) {
    const { isin, quoteFeedID, yieldType, yieldValue } = data;

    const { status, statusCode } = await sendYieldValue({
      isin,
      quoteFeedId: quoteFeedID,
      yieldType,
      yieldValue,
    });

    resentedPricesRequestsResults.push({ yieldType, sentSuccessfully: status === "ok", statusCode });
  }

  return resentedPricesRequestsResults;
};
